module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/72e455e9384497604e1d9d6dd00478bc.gif";